
import TableList from '../commom/tableList.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import {getEvaluationUpdate, getEvaluationSave, quesSignSave} from 'api/evaluation'

export default {

components: {
Loading,
XHeader,
Group,
Flexbox,
FlexboxItem,
XButton,
Checker,
CheckerItem,
TableList
},
data () {
return {
text: '加载中',
params: '',
title: '风险承受等级',
imgStyle: ''
}
},
computed: {
level () {
const result = this.params.result || ''
switch (result.toUpperCase()) {
case 'C1':
return 'R1'
case 'C2':
return 'R1、R2'
case 'C3':
return 'R1、R2、R3'
case 'C4':
return 'R1、R2、R3、R4'
case 'C5':
return 'R1、R2、R3、R4、R5'
}
}
},
created () {
this.params = this.$route.query
this.params.specialObj = this.$util.toBoolean(this.params.specialObj)
this.setRiskStyle()
},
methods: {
$_evaluation_back () {
this.$router.back()
this.$bridge.callHandler('reserveFinish', {message: '关闭h5'}, function (data) {
console.log('reserveFinish')
})
},
setRiskStyle () {
if (this.params.isLowAccept === '0') {
let imgBg = require('../../common/images/star.png')
this.imgStyle = {
'background': 'url(' + imgBg + ')',
'color': '#2E6BE6'
}
} else {
let imgBg = require('../../common/images/star_red.png')
this.imgStyle = {
'background': 'url(' + imgBg + ')',
'color': 'red'
}
}
},

$_evaluation_again () {
this.$router.push({path: '/evaluation/one'})
},

$_evaluation_update () {
getEvaluationUpdate({
sysCode: this.params.sysCode,
managerAdminUserId: this.params.managerId,
userId: this.params.userId,
afterResult: '风险承受最低类别'
}, this.params.au).then((res) => {
if (res.code === 0) {
this.$_evaluation_submit()
} else {
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
},
$_evaluation_checkSubmit () {
let isNeedSign = parseInt(this.params.isNeedSign)
if (isNeedSign === 1) {
this.$bridge.registerHandler('getSignData', (data) => {
setTimeout(() => {
this.$_getSignResult(data)
}, 30)
})
setTimeout(() => {
this.$bridge.callHandler('sign', {message: '用户签名', userId: this.params.userId, result: this.params.result}, (data) => {})
}, 30)
} else {
this.$_handleSubmit()
}
},

$_getSignResult (signFile) {
let data = {
sysCode: this.params.sysCode,
managerAdminUserId: this.params.managerId,
userId: this.params.invenstemUserId,  // 理财师添加的用户ID
platformUserId: this.params.platformUserId,
evaluationResultFile: this.params.evaluationResultFile,
signImagesFileInfo: signFile
}
console.log('合成签名提交的数据：', data)
this.$vux.loading.show({text: '签名合成中'})
quesSignSave(data, this.params.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
console.log('签章合成返回', res)
this.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign
this.$vux.toast.show({text: '签署成功', type: 'success'})
this.$_handleSubmit()
} else {
this.$vux.toast.show({text: res.msg, type: 'warn'})
}
}).catch(e => {
console.log(e)
this.$vux.loading.hide()
this.$vux.toast.show({text: '服务器繁忙, 请重试', type: 'warn'})
})
},

$_handleSubmit () {
this.$vux.loading.show({text: '提交中'})
let subData = JSON.parse(this.params.subData)
subData.evaluationResultFile = this.params.evaluationResultFile         
subData.evaluationResultFileSign = this.params.evaluationResultFileSign       
subData.afterResult = this.params.isLowAccept === 1 ? '风险承受最低类别' : this.params.result
console.log(subData, 111111)
getEvaluationSave(subData, this.params.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {





this.$_evaluation_submit(res.data.bean.evaluationId)
} else {
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
},
$_evaluation_submit (evaluationId) {
this.$vux.toast.show({type: 'success', text: '提交成功'})
this.$bridge.callHandler('getResult', {message: '最后确认', level: this.params.result, evaluationId}, function (data) {
console.log('submit')
})
},
$_view_quesDetail () {
let viewPdf = this.params.evaluationResultFileSign ? this.params.evaluationResultFileSign : this.params.evaluationResultFile
this.$bridge.callHandler('seePDF', {message: '查看pdf', pdfSign: viewPdf}, (data) => {
console.log('submit')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/lastLowEnd.vue